module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAARCAYAAADQWvz5AAAAhElEQVQ4T+2TPQ6CUBCEvzmAV5HWgoR7YIWdHggrKbmHsaEk3IV6bJ4JkheheBW45f58mczuikShRBz2ArJdA9eVvt0l3T69Xx7ZLoEiFI/AaQbtgCHknpLaKGg6ZPsAvIAs5HsglzTGFP/cmu0L8AiD56mCOWwJVAHNH7TyahbaNvxrb8BaKxJHlumWAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/yanzi_tab.png
// module id = cGmM
// module chunks = 1